const tableheadings = {
  columns: 'Columns',
  app_version: 'Core Version',
  name: 'Site Name',
  state: 'State',
  updates: 'Updates',
  tls_expiration: 'TLS/SSL',
  last_backup: 'Latest Backup',
  last_checked_backup: 'Last Test',
  phpversion: 'PHP',
  database_version: 'DB',
  report_setup: 'Report setup',
  disabled_update_sites: 'Disabled Update Sites',
  update_channel: 'Update Channel',
  translated_name: 'Extension Name',
  type: 'Type',
  sitecount: 'Installed',
  support_update: 'Updater Support',
  auto_update: 'Automatic Updates',
  site_name: 'Site',
  version: 'Current Version',
  next_version: 'Next Version',
  payload: 'Details',
  toVersion: 'Version',
  date: 'Date',
  id: 'ID'
}

export default tableheadings
